import { render, staticRenderFns } from "./AddFileToOfferGroupAction.vue?vue&type=template&id=b89c0e80&"
import script from "./AddFileToOfferGroupAction.vue?vue&type=script&lang=js&"
export * from "./AddFileToOfferGroupAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports